/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import demoData from '../../demoData/projectsData.json';
import './Projects.css';
import ProjectInfo from '../ProjectInfo/ProjectInfo';
import { Link } from 'react-router-dom';

const Projects = () => {
    const [projects, setProjects] = useState([]);
    const [visible, setVisible] = useState(6);

    useEffect(() => {
        setProjects(demoData)
    }, [])
    const allProjects = projects.slice(0, visible);
   
    

    return (
        <section className="container project spacing-pro" style={{overflowX: 'hidden', overflowY: 'hidden'}}>
            <div className="project-section">
                <h1 className="text-center mb-2 project-pad">My Projects</h1>
                <div className="card-group row">
                    {
                        allProjects.map(project => <ProjectInfo project={project} key={project.id}></ProjectInfo>)
                    }
                </div>
                <div className="text-center pb-4">
                    <Link  to="/projects" className="btn btn-outline-custom px-3 mt-4 fw-bold text-white">See More</Link>
                </div>
            </div>
        </section>
    );
};

export default Projects;